<template>
  <div class="paypalLoading">
    <h1>
      <i class='iconfont icon-jiazai xuanzhuan'></i>
      <br class="d-block d-sm-none">
      <span>PayPal支付创建中...</span>
    </h1>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultcommons from '../../util/resultcommons';

export default {
  name: 'paypalLoading',
  props:['no'],
  mixins: [generalMix],
  data () {
    return {
    }
  },
  components:{
  },
  methods:{
  },
  created() {
    resultcommons.apiPaypalurl(this,{no:this.no}).then(app=>{
      if (app.state === 200){
        window.location.href = app.data.url;
      }else{
        this.$message.showMsgBox({
          type: 'warning',
          content: app.message
        });
      }
    });
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.paypalLoading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30vh;
  h1{
    margin: 0;
    font-style: italic;
    i.xuanzhuan{
      font-size: 52px;
    }
  }
}
@media (max-width: 767px) {
  .paypalLoading{
    h1{
      font-size: 26px;
      text-align: center;
      span{
        display: block;
        margin-top: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/paypal.vue